/**
 * Rakhi gift wrap is not offered on socks or perfume products.
 */
(function () {
  if (window.GLGiftWrapEligibility) return;

  function norm(value) {
    return String(value || '')
      .toLowerCase()
      .trim();
  }

  function tagsString(item) {
    if (!item) return '';
    var tags = item.tags;
    if (Array.isArray(tags)) return tags.map(norm).join(' ');
    if (typeof tags === 'string') return norm(tags);
    return '';
  }

  function isIneligibleProduct(item) {
    if (!item) return true;

    var type = norm(item.product_type);
    var handle = norm(item.handle || item.product_handle);
    var title = norm(item.product_title || item.title);
    var sku = norm(item.sku || item.variant_sku);
    var tags = tagsString(item);

    if (
      type === 'socks' ||
      handle.indexOf('sock') !== -1 ||
      tags.indexOf('socks') !== -1 ||
      title.indexOf('sock') !== -1
    ) {
      return true;
    }

    if (
      handle.indexOf('perfume') !== -1 ||
      handle.indexOf('fragrance') !== -1 ||
      type.indexOf('perfume') !== -1 ||
      type === 'fragrance' ||
      tags.indexOf('perfume') !== -1 ||
      tags.indexOf('fragrance') !== -1 ||
      title.indexOf('perfume') !== -1 ||
      title.indexOf('fragrance') !== -1 ||
      sku.indexOf('frag') !== -1 ||
      sku.indexOf('perfume') !== -1
    ) {
      return true;
    }

    return false;
  }

  function itemFromButton(btn) {
    if (!btn || !btn.getAttribute) return null;
    var tagAttr = btn.getAttribute('data-product-tags') || '';
    return {
      product_id: btn.getAttribute('data-product-id'),
      handle: btn.getAttribute('data-product-handle'),
      product_type: btn.getAttribute('data-product-type'),
      product_title: btn.getAttribute('data-product-title'),
      sku: btn.getAttribute('data-product-sku'),
      tags: tagAttr ? tagAttr.split(',') : []
    };
  }

  function isProductEligible(itemOrBtn) {
    if (itemOrBtn && itemOrBtn.getAttribute) {
      if (itemOrBtn.getAttribute('data-gift-wrap-eligible') === 'false') return false;
      if (itemOrBtn.hasAttribute('data-gl-cart-gw') || itemOrBtn.hasAttribute('data-rakhi-gift-wrap')) {
        return !isIneligibleProduct(itemFromButton(itemOrBtn));
      }
    }
    return !isIneligibleProduct(itemOrBtn);
  }

  function cartAllowsGiftWrap(cart) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (item.handle === 'gift-wrap-it') continue;
      if (window.GL_GIFT_WRAP && String(item.variant_id) === String(window.GL_GIFT_WRAP.variantId)) {
        continue;
      }
      if (!isIneligibleProduct(item)) return true;
    }
    return false;
  }

  window.GLGiftWrapEligibility = {
    isIneligibleProduct: isIneligibleProduct,
    isProductEligible: isProductEligible,
    cartAllowsGiftWrap: cartAllowsGiftWrap,
    hideIneligibleCartButtons: function () {
      document.querySelectorAll('[data-gl-cart-gw]').forEach(function (btn) {
        if (!isProductEligible(btn)) {
          var row = btn.closest('.gl-cart-gw-row');
          if (row) row.remove();
          else btn.remove();
        }
      });
    }
  };
})();
